import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-00f736b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confetti-container" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'lottie-confetti',
  props: {
    size: {}
  },
  setup(__props: any) {

const props = __props;
const confettiSize = computed(() => props.size || "1000px");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("lottie-player", {
      style: _normalizeStyle(`height: ${confettiSize.value}; width: ${confettiSize.value}`),
      src: "/Lottie/lottie-confetti.json",
      autoplay: "",
      speed: "1"
    }, null, 4)
  ]))
}
}

})